import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {onDesktop} from "@pg-design/helpers-css";

const MAX_DESKTOP_CONTAINER_WIDTH = "112.8rem";

export const VendorContainer = styled.div`
    ${onDesktop(css`
        max-width: ${MAX_DESKTOP_CONTAINER_WIDTH};
        margin-left: auto;
        margin-right: auto;
    `)}

    padding-left: 2rem;
    padding-right: 2rem;
`;
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {onDesktop} from "@pg-design/helpers-css";

const MAX_DESKTOP_CONTAINER_WIDTH = "112.8rem";

export const VendorContainer = styled.div`
    ${onDesktop(css`
        max-width: ${MAX_DESKTOP_CONTAINER_WIDTH};
        margin-left: auto;
        margin-right: auto;
    `)}

    padding-left: 2rem;
    padding-right: 2rem;
`;
